import { combineReducers } from 'redux';
import dashboard from './dashboard';
import savedFilters from './savedFilters';

export default combineReducers({ dashboard, savedFilters });
